import { PathDisplays } from '@shared/common/text-to-html-path';
import { TruncateFrom } from '@shared/components/truncate';

export const UserHierarchyNodeColumns = [
    {
        displayName: 'Hierarchy Node',
        sortColumnName: 'hierarchyNode',
        // Venus renders a 'path' cell with its Path component (segments split on '|' or ' → ').
        // Truncating from the start keeps the leaf — the identifying part — visible on long paths.
        dataType: 'path',
        dataKey: 'text',
        settings: {
            sort: false,
            filter: false,
            multiple: false,
            pathDisplay: PathDisplays.Body,
            truncate: TruncateFrom.Start,
        },
    },
    {
        displayName: 'Actions',
        sortColumnName: 'actions',
        dataType: 'actions',
        dataKey: 'actions',
        settings: { sort: false, filter: false, multiple: false },
        css: 'pad-end',
    },
];

export const UserHierarchyNodeFilters = {
    sorting: null,

    pagination: null,

    advancedFilters: null,
};
